<ng-template #loading>
    <app-mat-spinner-overlay text="Henter saker..."></app-mat-spinner-overlay>
</ng-template>

<ng-template #loadingOrError>

    <ng-container *ngIf="errorObject; else loading">
        <div>
            {{errorObject}}
        </div>
    </ng-container>

</ng-template>


<div *ngIf="cases$ | async; let cases;else loading">

    <h1>Saksliste</h1>

    <p *ngIf="cases.length == 0" class="card-text m-3">Du har ingen saker</p>
    <p *ngIf="cases.length > 0" class="card-text m-3">Velg sak for å gå videre</p>


    <mat-table [dataSource]="cases" *ngIf="cases.length > 0">

        <ng-container matColumnDef="caseId">
            <mat-header-cell *matHeaderCellDef>Saksnummer</mat-header-cell>
            <mat-cell *matCellDef="let element" class='m-card-title'>
                <span>Sak&nbsp;</span>{{element.CaseId}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="complainer">
            <mat-header-cell *matHeaderCellDef>Klager</mat-header-cell>
            <mat-cell *matCellDef="let element">
                <div class="column-content">
                    {{element.Complainer?.FirstName}} {{element.Complainer?.LastName}}
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="company">
            <mat-header-cell *matHeaderCellDef>Foretak</mat-header-cell>
            <mat-cell *matCellDef="let element">
                <div class="column-content">
                    {{element.CompanyName}}
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef>Registrert dato</mat-header-cell>
            <mat-cell *matCellDef="let element">
                <div class="column-content">
                    <span>Registrert&nbsp;</span>{{element.RegDate | date: 'dd.MM.yyyy'}}        
                </div>
            </mat-cell>
        </ng-container>

        
        <ng-container matColumnDef="contact">
            <mat-header-cell *matHeaderCellDef>Kontaktperson</mat-header-cell>
            <mat-cell *matCellDef="let element">
                <div class="column-content" *ngIf="element.HasCorrespondent">
                    {{element.Correspondent?.FirstName}} {{element.Correspondent?.LastName}}&nbsp;
                        <span class="invitation-text" matTooltip="Sendt invitasjon om å bytte kontaktperson" *ngIf="element.HasContactInvitation">
                            <mat-icon>group_add</mat-icon>
                        </span>
                </div>
                <div class="column-content" *ngIf="element.HasContactInvitation && !element.HasCorrespondent">
                    <div class="invitation-text">
                        <span matTooltip="Sendt invitasjon om å legge til kontaktperson">Sendt invitasjon</span>&nbsp;<mat-icon>chevron_right</mat-icon>
                    </div>
                </div>

            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" class="click" (click)="openCase(row)"></mat-row>

    </mat-table>


</div>